import { useEffect, useRef } from 'react';
import './ApplicationAnnouncements.scss';
import UnsavedFormApplicationAnnouncement from './unsaved-form/UnsavedFormApplicationAnnouncement';
import VersionApplicationAnnouncement from './version/VersionApplicationAnnouncement';

const ApplicationAnnouncements = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const targetNode = containerRef.current;
    if (!targetNode) return;

    const calculateElements = () => {
      const elements = targetNode.querySelectorAll('.application-announcement-wrapper');
      document.documentElement.style.setProperty('--announcements-count', `${elements.length}`);
    };

    calculateElements();

    const observer = new MutationObserver(() => {
      calculateElements();
    });

    const config: MutationObserverInit = {
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    };

    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
      document.documentElement.style.setProperty('--announcements-count', '0');
    };
  }, []);

  return (
    <div className="application-announcements" ref={containerRef}>
      <VersionApplicationAnnouncement />
      <UnsavedFormApplicationAnnouncement />
    </div>
  );
};

export default ApplicationAnnouncements;
